<template>
  <div
    class="ui-holder"
    :class="[uiStatus, beginStatus, buttonStatus, backStatus, this.$store.state.menu.mobileMenu]"
  >
    <TopBar />
    <div class="begin">
      <button @click="onBegin">
        <FCButton text="begin" />
      </button>
    </div>
    <div class="ui">
      <button @click="onToggleUI" class="menu">
        <img src="@/assets/icons/menu.svg" />
      </button>
      <button @click="onToggleMobile" class="mobile-menu">
        <img src="@/assets/icons/menu.svg" />
      </button>
      <div class="menu-holder">
        <button
          v-for="(item, index) in menuItems"
          :key="index"
          class="nav-item"
          :class="[$store.state.menu.activeSection !== undefined ? $store.state.menu.activeSection == index ? 'selected' : 'not-selected' : 'normal']"
          @click="onNavClick(index)"
        >
          <FCNavButton :text="item.title" />
        </button>
      </div>
      <transition-group
        name="link-holder"
        tag="div"
        class="link-holder"
        v-if="$store.state.menu.activeSection !== undefined"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
      >
        <div key="back" class="nav-item mobile-back" @click="togglePrimary()">
          <FCNavBackButton :text="menuItems[$store.state.menu.activeSection].title" />
        </div>
        <router-link
          v-for="(item) in menuItems[$store.state.menu.activeSection].subnav"
          :key="item.url"
          class="nav-item"
          :to="item.url"
        >
          <FCNavButton :text="item.title" />
        </router-link>
      </transition-group>
      <a
        class="deposit-button"
        target="_blank"
        @click="$gtag.event('begin_checkout', {'event_label': 'Place Deposit Now'})"
        href="https://deposits.fccincinnati.com/events/2021%20reserved%20seat%20deposit/2020-12-31_19.30/fc%20cincinnati%20deposits?back=2&area=7a133315-3411-453c-ab26-41e4142dfcab&type=ga"
      >
        <FCOrangeButton text="Place Deposit Now" />
      </a>
      <a class="back-button" @click="$router.go(-1)">
        <img src="@/assets/icons/back.svg" />
      </a>
    </div>
  </div>
</template>

<script>
/*
<a
        v-if="showDeposit"
        class="deposit-button"
        target="_blank"
        @click="$gtag.event('begin_checkout', {'event_label': 'Place Deposit Now'})"
        href="https://deposits.fccincinnati.com/events/2021%20reserved%20seat%20deposit/2020-12-31_19.30/fc%20cincinnati%20deposits?back=2&area=7a133315-3411-453c-ab26-41e4142dfcab&type=ga"
      >
        <FCOrangeButton text="Place Deposit Now" />
      </a>
*/
import moment from "moment-timezone";
import { Fragment } from "vue-fragment";
import Velocity from "velocity-animate";
import FCButton from "@/components/patterns/FCButton";
import FCOrangeButton from "@/components/patterns/FCOrangeButton";
import FCNavButton from "@/components/patterns/FCNavButton";
import FCNavBackButton from "@/components/patterns/FCNavBackButton";
import TopBar from "@/components/Layout/TopBar/TopBar";

export default {
  name: "OverlayUI",
  components: {
    Fragment,
    FCButton,
    FCNavButton,
    FCOrangeButton,
    FCNavBackButton,
    TopBar,
  },
  props: {
    route: String,
  },
  computed: {
    //showDeposit: function() {
    //const today = moment();
    //const goLive = moment.tz("2020-05-12 08:00", "America/New_York");
    //console.log("today", today);
    //console.log("launch", goLive);
    //if (today > goLive) {
    //        return true;
    //    }
    //return false;
    //}
  },
  data() {
    return {
      activeRoute: "",
      beginStatus: "",
      uiStatus: "",
      buttonStatus: "",
      backStatus: "",
      links: [],
      menuItems: [],
      currentSectionTitle: "",
      currentSectionNavigation: [],
    };
  },
  watch: {
    route: function (newVal, oldVal) {
      this.activeRoute = newVal;
      this.backStatus = "show-back";
      this.$store.state.menu.mobileMenu = "";
      this.updateClasses();
    },
  },
  methods: {
    togglePrimary: function () {
      this.$store.state.menu.mobileMenu = "show-primary";
    },
    beforeLeave: function (el) {
      el.style.opacity = 0;
      el.style.height = 0;
    },
    beforeEnter: function (el) {
      el.style.opacity = 0;
      el.style.height = 0;
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 500;

      Velocity(
        el,
        { opacity: 1, height: el.scrollHeight },
        { delay: delay, complete: done }
      );
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 500;
      Velocity(el, { opacity: 0, height: 0 }, { delay: delay, complete: done });
    },
    onNavClick(index) {
      if (this.uiStatus == "hide-buttons") {
        this.onToggleUI();
        return;
      }
      if (
        this.menuItems[index].subnav.length === 1 &&
        this.menuItems[index].subnav[0].url === "virtual-tour" &&
        window.innerWidth <= 999
      ) {
        window.open(
          "https://3ddigitalvenue.com/3dmap/clients/fc-cincinnati/bowl/"
        );
        return;
      }
      this.$store.state.menu.activeSection = index;
      if (this.menuItems[index].subnav.length === 1) {
        this.$router.push(this.menuItems[index].subnav[0].url);
      }
      this.$store.state.menu.mobileMenu = "";
    },
    updateClasses() {
      if (this.activeRoute == "Home") {
        this.$store.state.menu.currentSectionNavigation = [];
        this.$store.state.menu.currentSectionTitle = "";
        this.beginStatus = "";
        this.uiStatus = "";
        this.buttonStatus = "";
        this.backStatus = "";
        this.uiToggleClass = "show-ui";
        this.$store.state.menu.activeSection = undefined;
        //this.links = [];
        this.$store.state.menu.currentSectionTitle = "";
        if (this.menuItems) {
          for (let i = 0; i < this.menuItems.length; i++) {
            this.menuItems[i].status = "normal";
          }
        }
      } else {
        this.buttonStatus = "show-ui";
        this.uiToggleClass = "hide-buttons";
        this.beginStatus = "hide-begin";
        this.uiStatus = "hide-buttons";
      }
    },
    onBegin() {
      if (this.uiStatus === "") {
        this.uiStatus = "show-ui";
      } else {
        this.uiStatus = "";
      }
    },
    onToggleUI() {
      if (this.uiStatus === "") {
        this.uiStatus = this.uiToggleClass;
      } else {
        this.uiStatus = "";
      }
    },
    onToggleMobile() {
      if (this.$store.state.menu.mobileMenu !== "") {
        this.$store.state.menu.mobileMenu = "";
      } else {
        this.$store.state.menu.mobileMenu = "show-links";
      }
    },
  },
  mounted() {
    this.activeRoute = this.$props.route;
    this.menuItems = this.$store.state.menu.menuItems;
    this.updateClasses();
  },
};
</script>

<style lang="scss" scoped>
.ui {
  z-index: 2;
  position: absolute;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s;
  button.nav-item {
    transition: all 0.2s;
    opacity: 0;
    height: 72px;
  }
}
.deposit-button {
  text-decoration: none;
  pointer-events: all;
}
.mobile-menu {
  right: 0;
  top: 0;
  width: 72px;
  height: 60px;
  display: none;
  z-index: 2;
  img {
    height: 60px;
  }
}

.show-ui {
  .ui {
    opacity: 1;
    .nav-item,
    button {
      pointer-events: all;
      opacity: 1;
    }
  }
  .begin {
    opacity: 0;
    pointer-events: none;
    button {
      pointer-events: none;
    }
  }
  .nav-item.not-selected {
    opacity: 0.5;
  }
  &.hide-buttons {
    .nav-item {
      &:not(.selected) {
        pointer-events: none;
        opacity: 0;
      }
    }
    a.nav-item {
      opacity: 0 !important;
    }
    .nav-item {
      &.selected {
        margin-bottom: 0;
      }
      &.not-selected {
        height: 0;
        margin-bottom: 0;
      }
    }
  }
}
.hide-begin {
  .begin {
    opacity: 0;
    pointer-events: none;
    button {
      pointer-events: none;
    }
  }
  .ui {
    opacity: 1;
    button {
      pointer-events: all;
      opacity: 1;
    }
  }
  .mobile-menu {
  }
}
.show-back {
  .back-button {
    opacity: 1;
    pointer-events: all;
  }
}
.back-button {
  transition: opacity 0.2s;
  position: absolute;
  background: none;
  opacity: 0;
  cursor: pointer;
}
.deposit-button {
  position: absolute;
  cursor: pointer;
}
.menu,
.mobile-menu {
  position: absolute;
  z-index: 1;
  img {
    height: 60px;
  }
}
.link-holder,
.menu-holder {
  position: absolute;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  .nav-item,
  button {
    position: relative;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}
.menu-holder {
  left: 125px;
}
.link-holder {
  left: 500px;
  .nav-item {
    pointer-events: all;
    transition: none;
  }
  a {
    text-decoration: none;
  }
}
.begin {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  bottom: 24%;
  left: 0;
  width: 100%;
  pointer-events: all;
  button {
    pointer-events: all;
    margin: 0 26px;
  }
}
.flipped {
  transform: scaleX(-1);
}
@media (max-width: 1000px) {
  .menu {
    right: 0;
    top: 0;
  }

  .hide-begin {
    .mobile-menu {
      display: block;
    }
    .menu {
      display: none;
    }
  }
  .back-button {
    right: 72px;
    top: 0;
    width: 72px;
    height: 60px;
    img {
      height: 60px;
    }
  }
  .deposit-button {
    right: 202px;
    top: 0;
  }
  .menu-holder,
  .link-holder {
    background-image: linear-gradient(90deg, #07173a 0%, #030a18 100%);
    top: 0;
    left: 0;
    width: 100%;
    min-height: calc(100vh - 60px);
    padding-top: 96px;
  }
  .ui-holder {
    &.hide-buttons {
      .menu-holder,
      .link-holder {
        opacity: 0;
        pointer-events: none;
        .nav-item {
          pointer-events: none;
        }
      }
    }
    &.show-primary {
      .link-holder {
        opacity: 0;
        pointer-events: none;
        .nav-item {
          pointer-events: none;
        }
      }
      .menu-holder {
        opacity: 1;
        pointer-events: all;
        .nav-item {
          opacity: 1 !important;
          pointer-events: all;
          height: auto;
        }
      }
    }
    &.show-secondary {
      .link-holder {
        opacity: 1;
        pointer-events: all;
        .nav-item {
          opacity: 1 !important;
          pointer-events: all;
        }
      }
    }
    &.show-links {
      button {
        &:not(.mobile-menu) {
          pointer-events: none !important;
        }
      }
    }
    button.nav-item {
      height: auto;
    }
    .nav-item {
      margin-bottom: 0 !important;
    }
  }
}
@media (max-width: 1000px) {
  .deposit-button {
    display: none;
  }
  .show-links,
  .show-secondary,
  .show-primary,
  .show-ui:not(.hide-begin) {
    .deposit-button {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      top: unset;
      right: unset;
      width: 100%;
    }
  }
}
@media (min-width: 999px) {
  .mobile-back {
    display: none;
  }
  .mobile-menu {
    display: none;
  }
  .menu {
    left: 30px;
    bottom: 20px;
  }
  .back-button {
    right: 30px;
    bottom: 20px;
  }
  .deposit-button {
    right: 140px;
    bottom: 20px;
  }
}
</style>